var _rect, _rect2, _g, _rect3, _g2, _g3, _rect4, _path, _path2, _path3, _path4, _rect5, _path5, _rect6, _rect7, _rect8, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPodcastFullColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 93,
    height: 93,
    rx: 20,
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 19,
    fill: "url(#paint2_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    filter: "url(#filter1_f)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 87,
    height: 87,
    rx: 18,
    fill: "url(#paint3_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 84,
    height: 82,
    rx: 16,
    fill: "url(#paint4_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 84,
    height: 82,
    rx: 16,
    fill: "url(#paint5_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    filter: "url(#filter4_f)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9.5,
    width: 83,
    height: 81,
    rx: 15.5,
    stroke: "url(#paint6_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9537 31.7346C37.9537 25.2538 43.2075 20 49.6883 20C56.1692 20 61.423 25.2538 61.423 31.7346V46.5115H37.9537V31.7346Z",
    fill: "url(#paint7_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9537 31.7346C37.9537 25.2538 43.2075 20 49.6883 20C56.1692 20 61.423 25.2538 61.423 31.7346V46.5115H37.9537V31.7346Z",
    fill: "url(#paint8_linear)",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2576 43.9039H60.1191V61.7232C60.1191 67.4839 55.4491 72.1539 49.6883 72.1539C43.9276 72.1539 39.2576 67.4839 39.2576 61.7232V43.9039Z",
    fill: "url(#paint9_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2576 43.9039H60.1191V61.7232C60.1191 67.4839 55.4491 72.1539 49.6883 72.1539C43.9276 72.1539 39.2576 67.4839 39.2576 61.7232V43.9039Z",
    fill: "url(#paint10_linear)",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 46.946,
    width: 37.3769,
    height: 1.73846,
    rx: 0.869231,
    fill: "url(#paint11_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4768 47.946H63.8999V63.896C63.8999 71.7449 57.5372 78.1076 49.6883 78.1076C41.8395 78.1076 35.4768 71.7449 35.4768 63.896V47.946Z",
    stroke: "url(#paint12_linear)",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7383,
    y: 44.7731,
    width: 33.9,
    height: 6.51923,
    rx: 2,
    fill: "url(#paint13_linear)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.65,
    y: 43.9039,
    width: 26.0769,
    height: 8.25769,
    rx: 3,
    fill: "url(#paint14_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.65,
    y: 43.9039,
    width: 26.0769,
    height: 8.25769,
    rx: 3,
    fill: "url(#paint15_linear)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9537 32.604H44.473C44.953 32.604 45.3422 32.9932 45.3422 33.4732C45.3422 33.9533 44.953 34.3425 44.473 34.3425H37.9537V32.604Z",
    fill: "url(#paint16_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0345 33.4732C54.0345 32.9932 54.4237 32.604 54.9038 32.604H61.423V34.3425H54.9038C54.4237 34.3425 54.0345 33.9533 54.0345 33.4732Z",
    fill: "url(#paint17_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9537 36.0808H44.473C44.953 36.0808 45.3422 36.47 45.3422 36.95C45.3422 37.4301 44.953 37.8193 44.473 37.8193H37.9537V36.0808Z",
    fill: "url(#paint18_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0345 36.95C54.0345 36.47 54.4237 36.0808 54.9038 36.0808H61.423V37.8193H54.9038C54.4237 37.8193 54.0345 37.4301 54.0345 36.95Z",
    fill: "url(#paint19_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9537 39.5577H44.473C44.953 39.5577 45.3422 39.9469 45.3422 40.427C45.3422 40.907 44.953 41.2962 44.473 41.2962H37.9537V39.5577Z",
    fill: "url(#paint20_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0345 40.427C54.0345 39.9469 54.4237 39.5577 54.9038 39.5577H61.423V41.2962H54.9038C54.4237 41.2962 54.0345 40.907 54.0345 40.427Z",
    fill: "url(#paint21_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 3,
    y: 3,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 2,
    y: 2,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 1,
    y: 3,
    width: 96,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 3,
    y: 5,
    width: 92,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 6,
    y: 8,
    width: 86,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BAEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8F4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49.5,
    y1: 3,
    x2: 49.5,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 50,
    y1: 4,
    x2: 50,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#287681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#66C2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B7E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 49.5,
    y1: 6,
    x2: 49.5,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#23808C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 49,
    y1: 9,
    x2: 49,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#A2E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 49,
    y1: 9,
    x2: 49,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEF3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 49,
    y1: 9,
    x2: 49,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 49.6883,
    y1: 20,
    x2: 49.6883,
    y2: 46.5115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#59E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 37.9537,
    y1: 35.2115,
    x2: 61.423,
    y2: 35.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 49.6883,
    y1: 43.9039,
    x2: 49.6883,
    y2: 72.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 39.2576,
    y1: 55.6385,
    x2: 60.1191,
    y2: 55.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531016,
    stopColor: "white",
    stopOpacity: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780886,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 49.6885,
    y1: 46.946,
    x2: 49.6885,
    y2: 48.6845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 49.6883,
    y1: 46.946,
    x2: 49.6883,
    y2: 79.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 49.6883,
    y1: 42.1654,
    x2: 49.6883,
    y2: 51.2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#2AACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#007D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 36.65,
    y1: 48.2501,
    x2: 61.4231,
    y2: 48.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#0098BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 62.7269,
    y1: 46.9462,
    x2: 36.65,
    y2: 46.9462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.258157,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478043,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 37.9537,
    y1: 33.4732,
    x2: 45.3422,
    y2: 33.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 54.0345,
    y1: 33.4732,
    x2: 61.423,
    y2: 33.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 37.9537,
    y1: 36.95,
    x2: 45.3422,
    y2: 36.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 54.0345,
    y1: 36.95,
    x2: 61.423,
    y2: 36.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 37.9537,
    y1: 40.427,
    x2: 45.3422,
    y2: 40.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 54.0345,
    y1: 40.427,
    x2: 61.423,
    y2: 40.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC6C6"
  })))));
}

export default SvgPodcastFullColor;